import React, { useState, useEffect, useRef } from "react";
import { FaTruckMoving } from "react-icons/fa";
import useCantidadActoresActivos from "../../../hooks/administrador/general/tarjetas/useCantidadActoresActivos";
import useCantidadPuntosGeneracionActivos from "../../../hooks/administrador/general/tarjetas/useCantidadPuntosGeneracionActivos";
import useCantidadImportadores from "../../../hooks/administrador/general/tarjetas/useCantidadImportadors";
import useCantidadRecolectada from "../../../hooks/administrador/general/tarjetas/useNfuRecolectados";
import useGestiondeReciclajeNfuCar from "../../../hooks/administrador/general/tarjetas/useGestionNfu";

const CARD_WIDTH = 400;

const CARDS = [
  {
    title: "Actores Activos",
    icon: <FaTruckMoving size={32} />,
    color: "#BBCD21",
    getValue: (data) =>
      Array.isArray(data)
        ? data?.[0]?.actores_activos ?? 0
        : data?.actores_activos ?? 0,
    hook: useCantidadActoresActivos,
  },
  {
    title: "Puntos de Generación Activos",
    icon: <FaTruckMoving size={32} />,
    color: "#BBCD21",
    getValue: (data) =>
      Array.isArray(data)
        ? data?.[0]?.actores_activos ?? 0
        : data?.actores_activos ?? 0,
    hook: useCantidadPuntosGeneracionActivos,
  },
  {
    title: "Importadores",
    icon: <FaTruckMoving size={32} />,
    color: "#BBCD21",
    getValue: (data) =>
      Array.isArray(data)
        ? data?.[0]?.actores_activos ?? 0
        : data?.actores_activos ?? 0,
    hook: useCantidadImportadores,
  },
  {
    title: "Gestión de Reciclaje NFU",
    icon: <FaTruckMoving size={32} />,
    color: "#BBCD21",
    getValue: (data) => {
      if (!data) return null;

      const unwrappedData = data.data !== undefined ? data.data : data;

      if (!unwrappedData) return null;

      const totalValues = Array.isArray(unwrappedData)
        ? unwrappedData.reduce(
            (acc, item) => {
              const gestionOperativa = parseFloat(
                item.cantidad_recolectada || 0
              );
              const reencauche = parseFloat(item.Reencauche || 0);
              const excedente = parseFloat(item.meta_establecida || 0);

              return {
                GESTION_OPERATIVA: acc.GESTION_OPERATIVA + gestionOperativa,
                REENCAUCHE: acc.REENCAUCHE + reencauche,
                EXCEDENTE: acc.EXCEDENTE + excedente,
                META_PROYECTADA:
                  acc.META_PROYECTADA +
                  gestionOperativa +
                  reencauche +
                  excedente,
              };
            },
            {
              GESTION_OPERATIVA: 0,
              REENCAUCHE: 0,
              EXCEDENTE: 0,
              META_PROYECTADA: 0,
            }
          )
        : {
            GESTION_OPERATIVA: 0,
            REENCAUCHE: 0,
            EXCEDENTE: 0,
            META_PROYECTADA: 0,
          };

      return totalValues;
    },
    customRender: (data) => {
      if (!data || typeof data !== "object") return "Cargando...";

      const isAccumulated =
        data.GESTION_OPERATIVA === 0 ||
        data.REENCAUCHE === 0 ||
        data.EXCEDENTE === 0;

      if (isAccumulated) {
        return (
          <div style={{ fontSize: "14px", lineHeight: "1.3" }}>
            <div style={{ marginBottom: "8px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "3px" }}>
                Gestión Operativa: {data.GESTION_OPERATIVA.toLocaleString()}
              </div>
              <div>Reencauche: {data.REENCAUCHE.toLocaleString()}</div>
              <div>Excedente: {data.EXCEDENTE.toLocaleString()}</div>
              <div>
                Meta Proyectada: {data.META_PROYECTADA.toLocaleString()}
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div style={{ fontSize: "14px", lineHeight: "1.3" }}>
            <div style={{ marginBottom: "8px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "3px" }}>
                Gestión Operativa: {data.GESTION_OPERATIVA.toLocaleString()}
              </div>
              <div>Reencauche: {data.REENCAUCHE.toLocaleString()}</div>
              <div>Excedente: {data.EXCEDENTE.toLocaleString()}</div>
              <div>
                Meta Proyectada: {data.META_PROYECTADA.toLocaleString()}
              </div>
            </div>
          </div>
        );
      }
    },
    hook: useGestiondeReciclajeNfuCar,
  },
  {
    title: "NFU Recolectados - Gestión Operativa",
    icon: <FaTruckMoving size={32} />,
    color: "#BBCD21",
    getValue: (data) => {
      return Array.isArray(data)
        ? data?.[0]?.Cantidad ?? 0
        : data?.Cantidad ?? 0;
    },
    hook: useCantidadRecolectada,
  },
];

const OperationStatsCarousel = ({ year, mes, token, idAdministrador }) => {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(null);

  const cardData = CARDS.map((card) =>
    card.hook(year, mes, token, idAdministrador)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % CARDS.length);
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX.current - touchEndX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) {
        setCurrent((prev) => (prev + 1) % CARDS.length);
      } else {
        setCurrent((prev) => (prev - 1 + CARDS.length) % CARDS.length);
      }
    }
    touchStartX.current = null;
  };

  const loading = cardData.some((d) => {
    return (
      d === null ||
      d === undefined ||
      (typeof d === "object" && d.loading === true) ||
      (Array.isArray(d) && d.length === 0)
    );
  });

  return (
    <div
      className="operation-stats-container chart-container"
      style={{
        position: "relative",
        width: "100%",
        height: 170,
        overflow: "hidden",
        margin: "0 auto",
        background: "#f5f5f5",
        boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        borderRadius: "12px",
      }}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {loading ? (
        <div
          className="loading"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          Cargando estadísticas...
        </div>
      ) : (
        <div
          className="carousel-track"
          style={{
            display: "flex",
            transition: "transform 0.6s cubic-bezier(.4,0,.2,1)",
            transform: `translateX(-${current * (CARD_WIDTH + 20)}px)`,
            width: `${CARDS.length * CARD_WIDTH}px`,
            height: "100%",
          }}
        >
          {CARDS.map((card, idx) => (
            <div
              key={card.title}
              className="stat-card"
              style={{
                width: CARD_WIDTH,
                height: "100%",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
                padding: "0 15px",
              }}
            >
              <div
                style={{
                  width: "92%",
                  height: "75%",
                  padding: 0,
                  margin: "0 auto",
                  marginTop: "15px",
                }}
              >
                <div
                  className="stat-card-inner"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    width: "85%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    padding: "0 20px",
                    boxSizing: "border-box",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    className="card-icon-container"
                    style={{
                      backgroundColor: card.color,
                      marginRight: "16px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                    }}
                  >
                    {card.icon}
                  </div>
                  <div className="card-content">
                    <h4 style={{ margin: "0 0 8px 0", fontSize: "14px" }}>
                      {card.title}
                    </h4>
                    <div
                      className="card-value"
                      style={{
                        fontSize: card.customRender ? "16px" : "32px",
                        fontWeight: "bold",
                        lineHeight: 1,
                      }}
                    >
                      {card.customRender
                        ? card.customRender(
                            card.getValue(
                              cardData[idx] && "data" in cardData[idx]
                                ? cardData[idx].data
                                : cardData[idx]
                            )
                          )
                        : card.getValue(
                            cardData[idx] && "data" in cardData[idx]
                              ? cardData[idx].data
                              : cardData[idx]
                          )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {/* Dots de navegación */}
      <div
        style={{
          position: "absolute",
          bottom: 15,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 8,
        }}
      >
        {CARDS.map((_, idx) => (
          <div
            key={idx}
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: idx === current ? "#BBCD21" : "#e0e0e0",
              cursor: "pointer",
            }}
            onClick={() => setCurrent(idx)}
          />
        ))}
      </div>
    </div>
  );
};

export default OperationStatsCarousel;
